"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wait = exports.asAsync = void 0;

/**
 * Allows NodeJS callback style functions to be called as if they were async. In other words, rather than calling
 * `someAsyncFunction(args, function (error, result) { // test error or do work and return result }`, you can call
 * `await asAsync(someAsyncFunction, args)` instead
 * @param fn Node style function to call
 * @param args
 * @returns {Promise}
 */
var asAsync = function asAsync(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return new Promise(function (resolve, reject) {
    fn.apply(void 0, args.concat([function (e, r) {
      return e ? reject(e) : resolve(r);
    }]));
  });
};
/**
 * Pauses execution for however long you want.
 * @param howLong
 * @returns {Promise<any>}
 */


exports.asAsync = asAsync;

var wait = function wait(howLong) {
  return new Promise(function (resolve) {
    setTimeout(resolve, howLong);
  });
};

exports.wait = wait;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/utils/async.js
// module id = 252
// module chunks = 0